// Naija Indie play counter for NameIt!'s listing on indiegames.ng. This is our own copy of
// their play.js, so no code from their server runs on our pages: we send only the game
// name, and they count one play per player per day. Failures are swallowed on purpose,
// because the counter must never affect the game.
export const PLAY_ENDPOINT = 'https://www.indiegames.ng/api/play';
const BODY = JSON.stringify({ game: 'nameit' });

export function countPlay({ sendBeacon = navigator.sendBeacon?.bind(navigator), fetchImpl = fetch } = {}) {
  try {
    if (sendBeacon && sendBeacon(PLAY_ENDPOINT, new Blob([BODY], { type: 'text/plain' }))) return true;
  } catch {
    // Fall through to fetch.
  }
  try {
    fetchImpl(PLAY_ENDPOINT, { method: 'POST', body: BODY, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } })?.catch?.(() => {});
    return true;
  } catch {
    return false;
  }
}
